import React, { Component } from "react";
import { connect } from "react-redux";
import "./LandingPage.component.scss";

import { User } from "../../../auth/reducers/users.reducer";
import { homeStoreSelectors } from "../../store/store";
import Footer from "../Footer/footer.component";

export interface LandingPageProps {
    userInfo: User;
}

class LandingPage extends Component<LandingPageProps, {}> {
    render() {
        if (this.props.userInfo != undefined) {
            return (
                <div className="landing-page">
                    <div className="background-circuits">
                        <svg
                            version="1.1"
                            id="Layer_1"
                            className="circuits"
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            viewBox="0 0 872.4 779.9"
                        >
                            <g className="st0">
                                <linearGradient
                                    id="SVGID_1_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="591.5429"
                                    y1="499.6311"
                                    x2="867.2296"
                                    y2="-91.5809"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st1"
                                    d="M738.4,272.4l-66.7,26.6L731.8,450l-16.2,37.6l30.6,76.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-30.2-75.9l16.2-37.6l-59.6-149.8l66.7-26.6L632.8,0h-2.6L738.4,272.4z"
                                >
                                    <circle
                                        cx="50"
                                        cy="50"
                                        r="40"
                                        stroke="black"
                                        strokeWidth="3"
                                        fill="red"
                                    />
                                </path>
                                <linearGradient
                                    id="SVGID_2_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="284.3639"
                                    y1="620.1476"
                                    x2="563.8113"
                                    y2="20.8708"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st2"
                                    d="M371,292.3l23.8-9.5l24.8,62.3l-13.7,28.9l58.1,145.9l20.5-8.2L525.2,614L509,651.6l32.3,81.1
                            c-1.5,1.2-2.2,3.3-1.4,5.2c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-2-2.8-3.1-4.8-2.8l-31.9-80.1l16.2-37.6
                            l-42-105.5l-20.5,8.2L408.5,374l13.7-28.9l-26.1-65.5l-23.8,9.5L257.3,0h-2.6L371,292.3z"
                                />
                                <linearGradient
                                    id="SVGID_3_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="272.9097"
                                    y1="610.8165"
                                    x2="546.1672"
                                    y2="24.814"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st3"
                                    d="M365.1,307.3l23.6-9.4l16.7,41.9l-14.1,33.3l64.5,162l23.6-9.4l36.5,91.8L499.8,655l26.6,66.9
                            c-1.4,1.2-2,3.3-1.3,5.1c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-2-2.9-3.2-5-2.8l-26.2-65.9l16.2-37.6l-37.8-94.9
                            l-23.6,9.4l-63.2-158.9l14.1-33.3l-17.9-45.1l-23.6,9.4L245.5,0h-2.6L365.1,307.3z"
                                />
                                <linearGradient
                                    id="SVGID_4_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="580.2888"
                                    y1="486.9781"
                                    x2="849.45"
                                    y2="-90.2399"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st4"
                                    d="M725.2,265.7l-66.7,26.6l62.4,156.8l-16.2,37.6l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-24.6-61.7l16.2-37.6l-61.9-155.5l66.7-26.6L622.2,0h-2.6L725.2,265.7z"
                                />
                                <linearGradient
                                    id="SVGID_5_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="518.8028"
                                    y1="410.0553"
                                    x2="749.1468"
                                    y2="-83.919"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st5"
                                    d="M607,270.7l23.6-9.4l42,105.4l-16.2,37.6l30.6,76.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-30.2-75.9l16.2-37.6L632,258.2l-23.6,9.4L501.8,0h-2.6L607,270.7z"
                                />
                                <linearGradient
                                    id="SVGID_6_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="507.5457"
                                    y1="397.3987"
                                    x2="732.3669"
                                    y2="-84.732"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st6"
                                    d="M601.5,283.4l23.6-9.4l36.5,91.8l-16.2,37.6l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-24.6-61.7l16.2-37.6l-37.8-94.9l-23.6,9.4L491.2,0h-2.6L601.5,283.4z"
                                />
                                <linearGradient
                                    id="SVGID_7_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="495.7245"
                                    y1="397.6707"
                                    x2="720.0903"
                                    y2="-83.4834"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st7"
                                    d="M595.5,298.1l23.6-9.4l30.8,77.4l-16.2,37.6l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-24.6-61.7l16.2-37.6l-32.1-80.6l-23.6,9.4L479.4,0h-2.6L595.5,298.1z"
                                />
                                <linearGradient
                                    id="SVGID_8_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="599.5482"
                                    y1="206.9118"
                                    x2="764.2156"
                                    y2="-146.2186"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st8"
                                    d="M608.3,68.7l23.6-9.4l42,105.4l-16.2,37.6l15.5,38.9l22.3-8.9c1.2,1.6,3.3,2.3,5.3,1.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.9-2.3-3.6-3.5-5.9-2.5c-1.9,0.8-3,2.7-2.8,4.7l-20,8l-14.2-35.7l16.2-37.6L633.2,56.2l-23.6,9.4
                            L583.5,0h-2.6L608.3,68.7z"
                                />
                                <linearGradient
                                    id="SVGID_9_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="587.2175"
                                    y1="219.6662"
                                    x2="755.1095"
                                    y2="-140.3794"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st9"
                                    d="M602.7,81.4l23.6-9.4l36.5,91.8l-16.2,37.6l22.5,56.5l15-6c1.2,1.6,3.3,2.3,5.3,1.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.9-2.3-3.6-3.5-5.9-2.5c-1.9,0.8-3,2.7-2.8,4.7l-12.7,5.1l-21.2-53.4l16.2-37.6l-37.8-94.9l-23.6,9.4L572.9,0h-2.6L602.7,81.4z"
                                />
                                <linearGradient
                                    id="SVGID_10_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="569.0699"
                                    y1="236.431"
                                    x2="742.4264"
                                    y2="-135.3333"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st10"
                                    d="M596.7,96.1l23.6-9.4l30.8,77.4L635,201.7l28.4,71.4c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-28-70.5l16.2-37.6l-32.1-80.6l-23.6,9.4L561.1,0h-2.6L596.7,96.1z"
                                />
                                <linearGradient
                                    id="SVGID_11_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="566.5784"
                                    y1="128.3259"
                                    x2="693.6683"
                                    y2="-144.2192"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st11"
                                    d="M588,113.2l23.6-9.4l18.7,46.9c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.8-1.9-2.7-3-4.7-2.8L613,100.7l-23.6,9.4L545.5,0h-2.6L588,113.2z"
                                />
                                <linearGradient
                                    id="SVGID_12_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="556.7358"
                                    y1="143.0737"
                                    x2="687.7722"
                                    y2="-137.9349"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st12"
                                    d="M582.5,125.9l23.6-9.4l20.6,51.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.8-1.9-2.7-3-4.7-2.8l-21.5-54.1l-23.6,9.4L534.9,0h-2.6L582.5,125.9z"
                                />
                                <linearGradient
                                    id="SVGID_13_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="545.5082"
                                    y1="154.8983"
                                    x2="679.3953"
                                    y2="-132.2236"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st13"
                                    d="M576.4,140.6l23.6-9.4l20.4,51.4c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.8-1.9-2.7-3-4.7-2.8L601.4,128l-23.6,9.4L523,0h-2.6L576.4,140.6z"
                                />
                                <linearGradient
                                    id="SVGID_14_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="527.4974"
                                    y1="216.3707"
                                    x2="684.4672"
                                    y2="-120.2522"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st14"
                                    d="M576.8,173.1l23.6-9.4l31.5,79.1l-21.4,8.5L586,189.6l8.9-3.5l14.1,35.5c-1.6,1.2-2.3,3.3-1.5,5.3
                            c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-15-37.8l-13.4,5.3l26.4,66.2l25.9-10.3l-33.3-83.6
                            l-23.6,9.4L510.5,0h-2.6L576.8,173.1z"
                                />
                                <linearGradient
                                    id="SVGID_15_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="684.984"
                                    y1="443.0962"
                                    x2="932.5746"
                                    y2="-87.8634"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <polygon
                                    className="st15"
                                    points="698.2,85 722,75.5 746.8,137.8 733.1,166.7 791.1,312.5 811.6,304.4 852.4,406.7 836.2,444.3
                            870.1,529.4 872.3,528.5 838.8,444.3 855,406.8 813,301.2 792.5,309.4 735.7,166.7 749.4,137.9 723.3,72.4 699.5,81.8 667,0
                            664.4,0 	"
                                />
                                <linearGradient
                                    id="SVGID_16_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="673.4145"
                                    y1="433.8628"
                                    x2="916.3436"
                                    y2="-87.1003"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <polygon
                                    className="st16"
                                    points="692.3,100 716,90.6 732.6,132.5 718.5,165.8 783,327.8 806.6,318.4 843.1,410.2 827,447.7
                            855.2,518.6 857.4,517.7 829.6,447.8 845.8,410.2 808,315.3 784.4,324.7 721.1,165.8 735.3,132.5 717.3,87.5 693.7,96.9 655.2,0
                            652.6,0 	"
                                />
                                <linearGradient
                                    id="SVGID_17_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="662.8377"
                                    y1="430.7735"
                                    x2="903.3693"
                                    y2="-85.0482"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st17"
                                    d="M776.6,337.7l23.6-9.4l30.8,77.4l-16.2,37.6l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-24.6-61.7l16.2-37.6l-32.1-80.6l-23.6,9.4L644.9,0h-2.6L776.6,337.7z"
                                />
                                <linearGradient
                                    id="SVGID_18_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="713.6766"
                                    y1="245.7729"
                                    x2="887.4729"
                                    y2="-126.9344"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st18"
                                    d="M718.4,39.8l23.6-9.4l42,105.4l-16.2,37.6L812,284.3c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-43.8-110l16.2-37.6L743.4,27.2l-23.6,9.4L705.2,0h-2.6L718.4,39.8z"
                                />
                                <linearGradient
                                    id="SVGID_19_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="702.1713"
                                    y1="228.2055"
                                    x2="870.0106"
                                    y2="-131.7268"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st19"
                                    d="M712.9,52.5l23.6-9.4l36.5,91.8l-16.2,37.6l36.1,90.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-35.8-89.9l16.2-37.6L737.8,40l-23.6,9.4L694.6,0H692L712.9,52.5z"
                                />
                                <linearGradient
                                    id="SVGID_20_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="689.5823"
                                    y1="213.4874"
                                    x2="851.9853"
                                    y2="-134.787"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st20"
                                    d="M706.9,67.1l23.6-9.4l30.8,77.4l-16.2,37.6l29,72.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-28.6-71.9l16.2-37.6l-32.1-80.6L708.2,64L682.8,0h-2.6L706.9,67.1z"
                                />
                                <linearGradient
                                    id="SVGID_21_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="380.5989"
                                    y1="506.3222"
                                    x2="635.6373"
                                    y2="-40.6093"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st21"
                                    d="M509.9,386.1l23.6-9.4l42,105.4l-16.2,37.6l30.6,76.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-30.2-75.9l16.2-37.6l-43.2-108.6l-23.6,9.4L358.5,0h-2.6L509.9,386.1z"
                                />
                                <linearGradient
                                    id="SVGID_22_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="369.3425"
                                    y1="493.6676"
                                    x2="619.2307"
                                    y2="-42.2192"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st22"
                                    d="M504.4,398.9l23.6-9.4l36.5,91.8l-16.2,37.6l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-24.6-61.7l16.2-37.6l-37.8-94.9l-23.6,9.4L347.9,0h-2.6L504.4,398.9z"
                                />
                                <linearGradient
                                    id="SVGID_23_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="357.5198"
                                    y1="493.9381"
                                    x2="606.3447"
                                    y2="-39.6684"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st23"
                                    d="M498.3,413.5l23.6-9.4l30.8,77.4l-16.2,37.6l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-24.6-61.7l16.2-37.6L523.3,401l-23.6,9.4L336.1,0h-2.6L498.3,413.5z"
                                />
                                <linearGradient
                                    id="SVGID_24_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="468.2645"
                                    y1="306.4031"
                                    x2="626.1282"
                                    y2="-32.1366"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st24"
                                    d="M511.1,184.1l23.6-9.4l42,105.4l-16.2,37.6l15.5,38.9l43-17.1c1.2,1.6,3.3,2.3,5.3,1.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.9-2.3-3.6-3.5-5.9-2.5c-1.9,0.8-3,2.7-2.8,4.7l-40.7,16.2l-14.2-35.7l16.2-37.6l-43.2-108.6l-23.6,9.4
                            L440.2,0h-2.6L511.1,184.1z"
                                />
                                <linearGradient
                                    id="SVGID_25_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="455.9325"
                                    y1="319.159"
                                    x2="621.1298"
                                    y2="-35.1077"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st25"
                                    d="M505.6,196.9l23.6-9.4l36.5,91.8l-16.2,37.6l22.5,56.5l35.7-14.2c1.2,1.6,3.3,2.3,5.3,1.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.9-2.3-3.6-3.5-5.9-2.5c-1.9,0.8-3,2.7-2.8,4.7l-33.4,13.3l-21.2-53.4l16.2-37.6l-37.8-94.9l-23.6,9.4
                            L429.6,0H427L505.6,196.9z"
                                />
                                <linearGradient
                                    id="SVGID_26_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="432.062"
                                    y1="355.827"
                                    x2="616.9642"
                                    y2="-40.6968"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st26"
                                    d="M499.6,211.5l23.6-9.4l30.8,77.4l-16.2,37.6l39.4,99.1c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-39.1-98.2l16.2-37.6L524.6,199l-23.6,9.4L417.8,0h-2.6L499.6,211.5z"
                                />
                                <linearGradient
                                    id="SVGID_27_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="428.3796"
                                    y1="224.5962"
                                    x2="566.7115"
                                    y2="-72.0575"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st27"
                                    d="M490.8,228.6l23.6-9.4l18.7,46.9c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.8-1.9-2.7-3-4.7-2.8l-19.5-49.1l-23.6,9.4L402.2,0h-2.6L490.8,228.6z"
                                />
                                <linearGradient
                                    id="SVGID_28_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="418.5431"
                                    y1="239.3468"
                                    x2="565.9882"
                                    y2="-76.8501"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st28"
                                    d="M485.3,241.3l23.6-9.4l20.6,51.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.8-1.9-2.7-3-4.7-2.8l-21.5-54.1l-23.6,9.4L391.6,0H389L485.3,241.3z"
                                />
                                <linearGradient
                                    id="SVGID_29_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="407.3135"
                                    y1="251.168"
                                    x2="561.8722"
                                    y2="-80.2843"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st29"
                                    d="M479.3,256l23.6-9.4l20.4,51.4c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.8-1.9-2.7-3-4.7-2.8l-21.3-53.6l-23.6,9.4L379.8,0h-2.6L479.3,256z"
                                />
                                <linearGradient
                                    id="SVGID_30_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="389.3017"
                                    y1="312.6408"
                                    x2="569.9157"
                                    y2="-74.687"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st30"
                                    d="M479.7,288.5l23.6-9.4l31.5,79.1l-21.4,8.5L488.8,305l8.9-3.5l14.1,35.5c-1.6,1.2-2.3,3.3-1.5,5.3
                            c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-15-37.8l-13.4,5.3l26.4,66.2l25.9-10.3L504.6,276
                            l-23.6,9.4L367.2,0h-2.6L479.7,288.5z"
                                />
                                <linearGradient
                                    id="SVGID_31_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="190.7183"
                                    y1="672.5986"
                                    x2="493.6761"
                                    y2="22.9037"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st31"
                                    d="M411.2,479.7l-66.7,26.6l60.1,151.1l-16.2,37.6l30.6,76.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-30.2-75.9l16.2-37.6l-59.6-149.8l66.7-26.6L223,0h-2.6L411.2,479.7z"
                                />
                                <linearGradient
                                    id="SVGID_32_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="179.4657"
                                    y1="659.9449"
                                    x2="475.6229"
                                    y2="24.8339"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st32"
                                    d="M398,473l-66.7,26.6l62.4,156.8l-16.2,37.6l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8L380.1,694l16.2-37.6l-61.9-155.5l66.7-26.6L212.4,0h-2.6L398,473z"
                                />
                                <linearGradient
                                    id="SVGID_33_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="198.7181"
                                    y1="379.8754"
                                    x2="390.1791"
                                    y2="-30.7141"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st33"
                                    d="M281.1,276l23.6-9.4l42,105.4l-16.2,37.6l15.5,38.9l22.3-8.9c1.2,1.6,3.3,2.3,5.3,1.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.9-2.3-3.6-3.5-5.9-2.5c-1.9,0.8-3,2.7-2.8,4.7l-20,8l-14.2-35.7l16.2-37.6L306,263.5l-23.6,9.4
                            L209.7,90c0,0,0,0-0.1,0L173.7,0h-2.6L281.1,276z"
                                />
                                <linearGradient
                                    id="SVGID_34_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="186.4575"
                                    y1="392.6686"
                                    x2="381.4377"
                                    y2="-25.4678"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st34"
                                    d="M199.1,96.7C199.1,96.7,199.1,96.7,199.1,96.7l76.4,192.1l23.6-9.4l36.5,91.8l-16.2,37.6l22.5,56.5l15-6
                            c1.2,1.6,3.3,2.3,5.3,1.5c2.3-0.9,3.5-3.6,2.5-5.9c-0.9-2.3-3.6-3.5-5.9-2.5c-1.9,0.8-3,2.7-2.8,4.7l-12.7,5.1l-21.2-53.4
                            l16.2-37.6l-37.8-94.9l-23.6,9.4L201.2,95.4c0,0,0,0-0.1,0L163.1,0h-2.4L199.1,96.7z"
                                />
                                <linearGradient
                                    id="SVGID_35_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="168.24"
                                    y1="409.3953"
                                    x2="369.0105"
                                    y2="-21.1584"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st35"
                                    d="M269.5,303.4l23.6-9.4l30.8,77.4L307.8,409l28.4,71.4c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-28-70.5l16.2-37.6l-32.1-80.6l-23.6,9.4l-79.3-199.2c0,0,0,0-0.1,0L151.3,0h-2.6
                            L269.5,303.4z"
                                />
                                <linearGradient
                                    id="SVGID_36_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="165.75"
                                    y1="301.2925"
                                    x2="320.6691"
                                    y2="-30.9326"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st36"
                                    d="M260.8,320.5l23.6-9.4L303,358c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.8-1.9-2.7-3-4.7-2.8L285.7,308l-23.6,9.4l-83.4-209.6c0,0,0,0-0.1,0L135.7,0h-2.6L260.8,320.5z"
                                />
                                <linearGradient
                                    id="SVGID_37_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="155.9067"
                                    y1="316.0417"
                                    x2="315.0347"
                                    y2="-25.2095"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st37"
                                    d="M255.2,333.2l23.6-9.4l20.6,51.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.8-1.9-2.7-3-4.7-2.8l-21.5-54.1l-23.6,9.4L169.8,112c0,0,0,0-0.1,0L125.1,0h-2.6L255.2,333.2z"
                                />
                                <linearGradient
                                    id="SVGID_38_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="144.681"
                                    y1="327.8636"
                                    x2="306.9066"
                                    y2="-20.0304"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st38"
                                    d="M249.2,347.9l23.6-9.4l20.4,51.4c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9
                            c-0.8-1.9-2.7-3-4.7-2.8l-21.3-53.6l-23.6,9.4l-90.9-228.5c0,0,0,0-0.1,0L113.3,0h-2.6L249.2,347.9z"
                                />
                                <linearGradient
                                    id="SVGID_39_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="126.6686"
                                    y1="389.3388"
                                    x2="312.1578"
                                    y2="-8.444"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st39"
                                    d="M249.6,380.4l23.6-9.4l31.5,79.1l-21.4,8.5l-24.6-61.7l8.9-3.5l14.1,35.5c-1.6,1.2-2.3,3.3-1.5,5.3
                            c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-15-37.8l-13.4,5.3l26.4,66.2l25.9-10.3l-33.3-83.6
                            l-23.6,9.4l-102.3-257c0,0-0.1,0-0.1,0L100.7,0h-2.6L249.6,380.4z"
                                />
                                <linearGradient
                                    id="SVGID_40_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="262.006"
                                    y1="603.7373"
                                    x2="530.4831"
                                    y2="27.9864"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st40"
                                    d="M449.3,545l23.6-9.4l30.8,77.4l-16.2,37.6l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-24.6-61.7l16.2-37.6l-32.1-80.6l-23.6,9.4L235.2,0h-2.6L449.3,545z"
                                />
                                <linearGradient
                                    id="SVGID_41_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="312.8902"
                                    y1="418.7585"
                                    x2="508.5274"
                                    y2="-0.7867"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st41"
                                    d="M391.2,247.1l23.6-9.4l42,105.4l-16.2,37.6l44.1,110.9c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-43.8-110l16.2-37.6l-43.2-108.6l-23.6,9.4L295.5,0h-2.6L391.2,247.1z"
                                />
                                <linearGradient
                                    id="SVGID_42_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="301.3849"
                                    y1="401.1905"
                                    x2="487.9887"
                                    y2="1.0172"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st42"
                                    d="M385.7,259.8l23.6-9.4l36.5,91.8l-16.2,37.6l36.1,90.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-35.8-89.9l16.2-37.6l-37.8-94.9l-23.6,9.4L284.9,0h-2.6L385.7,259.8z"
                                />
                                <linearGradient
                                    id="SVGID_43_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="288.7931"
                                    y1="386.472"
                                    x2="467.179"
                                    y2="3.9222"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st43"
                                    d="M379.7,274.4l23.6-9.4l30.8,77.4L417.9,380l29,72.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-28.6-71.9l16.2-37.6l-32.1-80.6l-23.6,9.4L273.1,0h-2.6L379.7,274.4z"
                                />
                                <linearGradient
                                    id="SVGID_44_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="48.9475"
                                    y1="527.7628"
                                    x2="285.0558"
                                    y2="21.4268"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st44"
                                    d="M98.4,186.5l23.8-9.5l24.8,62.3l-13.7,28.9l58.1,145.9l20.5-8.2l40.7,102.4l-16.2,37.6l33.9,85.1l2.2-0.9
                            L239,545.9l16.2-37.6l-42-105.6l-20.5,8.2l-56.8-142.7l13.7-28.9l-26.1-65.5l-23.8,9.5l-18.9-47.6c0,0-0.1,0-0.1,0L26.3,0h-2.6
                            L98.4,186.5z"
                                />
                                <linearGradient
                                    id="SVGID_45_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="37.4487"
                                    y1="518.5609"
                                    x2="284.487"
                                    y2="-11.2146"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st45"
                                    d="M92.5,201.6l23.6-9.4l16.7,41.9l-14.1,33.2l64.5,162l23.6-9.4l36.5,91.8l-16.2,37.6l28.2,70.9l2.2-0.9
                            l-27.9-70l16.2-37.6l-37.8-94.9l-23.6,9.4l-63.2-158.9l14.1-33.3L117.5,189l-23.6,9.4l-24.1-60.7c0,0,0,0-0.1,0L14.7,0h-2.6
                            L92.5,201.6z"
                                />
                                <linearGradient
                                    id="SVGID_46_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="26.8485"
                                    y1="515.4621"
                                    x2="263.7707"
                                    y2="7.3809"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st46"
                                    d="M176.8,439.2l23.6-9.4l30.8,77.4L215,544.9l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-24.6-61.7l16.2-37.6l-32.1-80.6l-23.6,9.4l-118-296.6c0,0-0.1,0-0.1,0L4.4,0H1.8
                            L176.8,439.2z"
                                />
                                <linearGradient
                                    id="SVGID_47_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="106.7294"
                                    y1="577.7784"
                                    x2="360.5898"
                                    y2="33.373"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st47"
                                    d="M118.6,141.3l23.6-9.4l42,105.4L168,274.9l44.1,110.9c-1.6,1.2-2.2,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-43.8-110l3.1-7.2l94.6,237.6l23.6-9.4l30.8,77.4L306.5,611l24.9,62.6
                            c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8L309.2,611l16.2-37.6
                            l-32.1-80.6l-23.6,9.4l-94.5-237.6l4.8-11.1l94.4,237.2l23.6-9.4l36.5,91.7l-16.2,37.6l24.9,62.6c-1.6,1.2-2.3,3.3-1.5,5.3
                            c0.9,2.3,3.6,3.5,5.9,2.5c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-24.6-61.7l16.2-37.6l-37.8-94.9l-23.6,9.4l-94.4-237.2
                            l4.2-9.7L279.8,478l23.6-9.4l42,105.4l-16.2,37.6l30.6,76.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-30.2-75.9l16.2-37.6l-43.2-108.6l-23.6,9.4l-94.4-237.3l0.1-0.2l-43.2-108.6
                            l-23.6,9.4l-3.6-9c0,0,0,0,0,0L64.6,0H62L118.6,141.3z"
                                />
                                <linearGradient
                                    id="SVGID_48_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="66.1598"
                                    y1="312.8828"
                                    x2="223.2772"
                                    y2="-24.0567"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st48"
                                    d="M113.1,154.1l23.6-9.4l36.5,91.8L157,274l36.1,90.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8L159.7,274l16.2-37.6L138,141.5l-23.6,9.4l-7.9-19.7c0,0,0,0,0,0L54,0h-2.6
                            L113.1,154.1z"
                                />
                                <linearGradient
                                    id="SVGID_49_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="53.559"
                                    y1="298.1588"
                                    x2="204.528"
                                    y2="-25.5953"
                                >
                                    <stop
                                        offset="0"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0.64
                                        }}
                                    />
                                    <stop
                                        offset="0.8715"
                                        style={{
                                            stopColor: "#FF8096",
                                            stopOpacity: 0
                                        }}
                                    />
                                </linearGradient>
                                <path
                                    className="st49"
                                    d="M107.1,168.7l23.6-9.4l30.8,77.4l-16.2,37.6l29,72.8c-1.6,1.2-2.3,3.3-1.5,5.3c0.9,2.3,3.6,3.5,5.9,2.5
                            c2.3-0.9,3.5-3.6,2.5-5.9c-0.8-1.9-2.7-3-4.7-2.8l-28.6-71.9l16.2-37.6L132,156.2l-23.6,9.4l-12.8-32.3c0,0,0,0-0.1,0L42.2,0h-2.6
                            L107.1,168.7z"
                                />
                            </g>
                        </svg>
                    </div>
                    <div className="landing-container">
                        <h1 className="h1">
                            Welcome,{" "}
                            {this.props.userInfo.first_name +
                                " " +
                                this.props.userInfo.last_name}
                            !
                        </h1>
                        <p className="h2">
                            Support for system server, easily accessible through
                            web browser.
                        </p>
                        <p className="h2">- Manage Halls and Servers;</p>
                        <p className="h2">
                            - Manage Licensing and Certificates;
                        </p>
                        <p className="h2">
                            - Manage Games, Bundles and Game configurations;
                        </p>
                        <p className="h2">- Product actions;</p>
                    </div>
                    <Footer />
                </div>
            );
        }

        return null;
    }
}

const mapDispatchToProps = {};

const mapStateToProps = state => ({
    userInfo: homeStoreSelectors.userInfo(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);
